var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57143 33.9643C2.58929 33.9643 1.74881 33.6149 1.05 32.9161C0.35 32.2161 0 31.375 0 30.3928V10.75C0 9.76785 0.35 8.92737 1.05 8.22856C1.74881 7.52856 2.58929 7.17856 3.57143 7.17856H10.7143V3.60713C10.7143 2.62499 11.0643 1.78392 11.7643 1.08392C12.4631 0.38511 13.3036 0.0357056 14.2857 0.0357056H21.4286C22.4107 0.0357056 23.2518 0.38511 23.9518 1.08392C24.6506 1.78392 25 2.62499 25 3.60713V7.17856H32.1429C33.125 7.17856 33.9661 7.52856 34.6661 8.22856C35.3649 8.92737 35.7143 9.76785 35.7143 10.75V30.3928C35.7143 31.375 35.3649 32.2161 34.6661 32.9161C33.9661 33.6149 33.125 33.9643 32.1429 33.9643H3.57143ZM14.2857 7.17856H21.4286V3.60713H14.2857V7.17856ZM32.1429 23.25H23.2143V26.8214H12.5V23.25H3.57143V30.3928H32.1429V23.25ZM16.0714 23.25H19.6429V19.6786H16.0714V23.25ZM3.57143 19.6786H12.5V16.1071H23.2143V19.6786H32.1429V10.75H3.57143V19.6786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCenter);
export default __webpack_public_path__ + "static/media/business_center.e527549c2e0459eb140e45642faf23fd.svg";
export { ForwardRef as ReactComponent };